import React, { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// REDUX
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { getUserByUsername } from "../../redux/user";

// CONTEXT
import useAuth from "../../hooks/useAuth";

const AccountUIContext = createContext();

export const useAccountUIContext = () => {
  return useContext(AccountUIContext);
};

export const AccountUIConsumer = AccountUIContext.Consumer;

export function AccountUIProvider({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authData, saveUserData } = useAuth();
  const { getUserByUsernameData } = useSelector(
    (state) => ({
      getUserByUsernameData: state.GetUserByUsernameData,
    }),
    shallowEqual
  );

  const { data } = getUserByUsernameData;

  useEffect(() => {
    dispatch(getUserByUsername(authData));
  }, [dispatch, authData]);

  const dataUIEvents = {
    goToAccountResetPassword: (id) => {
      navigate(`/account/reset-password`, {
        state: {
          showDialog: true,
        },
      });
    },
    goToAccountProfileEdit: (id) => {
      navigate(`/account/profile/${id}/edit`, {
        state: {
          showDialog: true,
        },
      });
    },
    onHide: () => {
      navigate(-1);
    },
  };

  const handleResetData = async () => {
    await dispatch(getUserByUsername(authData));
  };

  const value = {
    data,
    authData,
    saveUserData,
    handleResetData,
    goToAccountResetPassword: dataUIEvents.goToAccountResetPassword,
    goToAccountProfileEdit: dataUIEvents.goToAccountProfileEdit,
    onHide: dataUIEvents.onHide,
  };

  return (
    <AccountUIContext.Provider value={value}>
      {children}
    </AccountUIContext.Provider>
  );
}
